// AUTO-GENERATED by scripts/update-ai-models.ts — do not edit manually
// Re-run: pnpm codegen:models

export const SupportedOpenAiModels = [
  "openai:gpt-6-astra",
  "openai:gpt-6-luna",
  "openai:gpt-6-sol",
  "openai:gpt-5",
  "openai:gpt-5-chat-latest",
  "openai:gpt-5-codex",
  "openai:gpt-5-mini",
  "openai:gpt-5-nano",
  "openai:gpt-5-pro",
  "openai:gpt-5-search-api",
  "openai:gpt-5.1",
  "openai:gpt-5.1-chat-latest",
  "openai:gpt-5.1-codex",
  "openai:gpt-5.1-codex-max",
  "openai:gpt-5.1-codex-mini",
  "openai:gpt-5.2",
  "openai:gpt-5.2-chat-latest",
  "openai:gpt-5.2-codex",
  "openai:gpt-5.2-pro",
  "openai:gpt-5.3-chat-latest",
  "openai:gpt-5.3-codex",
  "openai:gpt-5.4",
  "openai:gpt-5.4-mini",
  "openai:gpt-5.4-nano",
  "openai:gpt-5.4-pro",
  "openai:gpt-5.5",
  "openai:gpt-5.5-pro",
  "openai:gpt-5.6-luna",
  "openai:gpt-5.6-sol",
  "openai:gpt-5.6-terra",
  "openai:gpt-4.1",
  "openai:gpt-4.1-mini",
  "openai:gpt-4.1-nano",
  "openai:gpt-4o-mini",
  "openai:gpt-4o-mini-search-preview",
  "openai:gpt-4o-mini-transcribe",
  "openai:gpt-4o-mini-tts",
  "openai:o3",
  "openai:o3-deep-research",
  "openai:o3-mini",
  "openai:o3-pro",
  "openai:o4-mini",
  "openai:o4-mini-deep-research",
] as const;

export const SupportedGoogleModels = [
  "google:gemini-3-flash-preview",
  "google:gemini-3-pro-image",
  "google:gemini-3-pro-image-preview",
  "google:gemini-3.1-flash-image",
  "google:gemini-3.1-flash-image-preview",
  "google:gemini-3.1-flash-lite",
  "google:gemini-3.1-flash-lite-image",
  "google:gemini-3.1-flash-lite-preview",
  "google:gemini-3.1-pro-preview",
  "google:gemini-3.1-pro-preview-customtools",
  "google:gemini-3.5-flash",
  "google:gemini-3.5-flash-lite",
  "google:gemini-3.6-flash",
  "google:gemini-3.7-flash",
  "google:gemini-3.8-flash",
  "google:gemini-2.5-computer-use-preview-10-2025",
  "google:gemini-2.5-flash",
  "google:gemini-2.5-flash-image",
  "google:gemini-2.5-flash-lite",
  "google:gemini-2.5-flash-preview-tts",
  "google:gemini-2.5-pro",
  "google:gemini-2.5-pro-preview-tts",
] as const;

export const SupportedAnthropicModels = [
  "anthropic:claude-opus-4-6",
  "anthropic:claude-opus-4-7",
  "anthropic:claude-opus-4-8",
  "anthropic:claude-opus-5",
  "anthropic:claude-opus-5-5",
  "anthropic:claude-sonnet-4-6",
  "anthropic:claude-sonnet-5",
  "anthropic:claude-haiku-4-5",
] as const;

export const SupportedAiModels = [
  ...SupportedOpenAiModels,
  ...SupportedGoogleModels,
  ...SupportedAnthropicModels,
] as const;
